import React, { useRef, useState } from "react";
import { QrReader } from "react-qr-reader";
import { Modal, Button, Spinner } from "react-bootstrap";

const MeetingQRScanner = ({ show, onJoin, onClose }) => {
  const [scanned, setScanned] = useState(false);
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(true);
  const [Error,setError]=useState(false)
  const fileRef = useRef();

  return (
    <Modal
      style={{backdropFilter:"blur(4px)"}}
      show={show}
      onHide={onClose}
      centered
      size="md"
      className="isscannermodal"
      backdrop="static"
      keyboard={true}
    >
   <Modal.Header
  closeButton
  style={{ border: "none", justifyContent: "center", position: "relative" }}
>
  <Modal.Title
    className="colorset"
    style={{ fontSize: "20px", width: "100%", textAlign: "center" }}
  >
    Scan Meeting QR Code
  </Modal.Title>
</Modal.Header>
      <Modal.Body  style={{paddingTop:"0px"}}>
         <center><p className="colorset" style={{ fontSize: 16}}>
          Align the QR code inside the camera view.
        </p></center> 
        
        {loading && (
          <div style={{ textAlign: "center", margin: "20px 0" }}>
            <Spinner animation="border" variant="primary" />
            <p style={{ marginTop: 10 }}>Starting camera...</p>
          </div>
        )}

        <div style={{ display: loading ? "none" : "block" }}>
          <QrReader
            constraints={{ video: { facingMode: "environment" } }}
            scanDelay={500}
            onResult={(res) => {
              if (loading) setLoading(false); 

              if (res?.text && !scanned) {
                
                setScanned(true);
                setResult(res.text);
                console.log("Scanned QR:", res.text);
                onJoin(res.text);
              }
            }}
            containerStyle={{ width: "100%" }}
            videoStyle={{ width: "100%", height: "400px",  borderRadius: "8px" }}
          />
        </div>

      </Modal.Body>
    </Modal>
  );
};

export default MeetingQRScanner;
